// @flow
export { default } from './PostComment';



// WEBPACK FOOTER //
// ./src/components/post/PostComment/index.js